// TODO: DGC-27954; restore actions

import LocaleService from '@/modules/register/modules/RegistrationPage/services/locale.service';
import { ManifestService, getOrganization } from '@/shared/services';
import { getDynamicConfig, getLatestMatchingLinkInfo, getTestFlow } from '@/shared/services/resourcesService';

function isV2LinkInfo(linkInfo: any) {
  return !linkInfo.payload.accessConfig;
}

const actions = {
  async loadOrganizationConfig({ commit }: any) {
    const organizationConfig = await getOrganization();

    commit('setOrganizationConfig', organizationConfig);
  },
  async loadTestFlow({ commit }: any, payload: { testCanonicalId: string, locale: string }) {
    const testFlow = await getTestFlow(payload);

    commit('setTestFlow', testFlow);
  },
  async loadV2LinkInfo({ commit }: any, linkInfo: any) {
    const manifest = await ManifestService.getV2Manifest(linkInfo.payload.manifestPath);

    commit('setLinkInfo', {
      payload: linkInfo.payload,
    });

    return {
      manifest: {
        ...manifest,
        storage: 'UI_ASSETS',
      },
    };
  },
  async loadLinkInfo({ commit, dispatch }: any, linkId: string) {
    const linkInfo = await getLatestMatchingLinkInfo(linkId);

    if (isV2LinkInfo(linkInfo)) {
      return dispatch('loadV2LinkInfo', linkInfo);
    }

    const { payload, accessConfig: manifest } = linkInfo.payload;

    payload.baseConfigURL = payload?.baseUrl;

    commit('setLinkInfo', { payload, manifest });
    commit('setManifest', manifest);

    if (payload?.lang) {
      commit('setLocale', payload?.lang);
    }

    return {
      manifest,
    };
  },
  async loadLocale({ commit }: any, localeId: string) {
    const locale = await LocaleService.get(localeId);

    commit('setLocale', locale);
  },
  async loadDynamicConfig({ commit }: any) {
    const dynamicConfig = await getDynamicConfig();

    commit('setDynamicConfig', dynamicConfig);
  },
};

export default actions;
